import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { authFetch } from '../services/api';

export default function SubscriptionStatus() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadStatus = useCallback(async () => {
    try {
      const res = await authFetch('/api/subscriptions/status');
      if (res.ok) setStatus(await res.json());
    } catch { /* silence */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { loadStatus(); }, [loadStatus]);
  useEffect(() => {
    const h = () => loadStatus();
    window.addEventListener('passio-upload-success', h);
    return () => window.removeEventListener('passio-upload-success', h);
  }, [loadStatus]);

  if (loading || !status) return null;

  const isPremium = status.tier === 'premium';
  const used = status.tracks_used_this_month || 0;
  const limit = status.limit_this_month || (isPremium ? (status.premium_track_limit || 30) : (status.free_track_limit || 3));
  const pct = Math.min(100, Math.round((used / Math.max(1, limit)) * 100));

  return (
    <div>
      <div className="sub-card-head">
        <div>
          <span className="sub-kicker">Votre abonnement</span>
          <h3>Plan <em>{isPremium ? 'Premium' : 'Free'}</em></h3>
        </div>
        <span className="sub-pill">{status.is_expiring_soon ? `Expire J-${status.days_until_expiry}` : 'Actif'}</span>
      </div>
      <div className="sub-progress-label"><span>Tracks utilisés</span><b>{used} / {limit}</b></div>
      <div className="sub-progress"><span style={{ width: `${pct}%` }} /></div>
      {isPremium && (status.effective_expires_at || status.subscription_expires_at) && (
        <p style={{ fontSize: '.72rem', color: 'var(--ink-soft)' }}>
          Actif jusqu’au {new Date(status.effective_expires_at || status.subscription_expires_at).toLocaleDateString('fr-FR')}
        </p>
      )}
      {!isPremium && (
        <Link to="/dashboard/premium" className="sub-link" style={{ marginTop: 8, display: 'inline-flex' }}>
          Premium : {status.premium_track_limit || 30} tracks/mois, commission {Math.round((status.premium_commission_rate || 0.15) * 100)}%
        </Link>
      )}
    </div>
  );
}
